var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{on:{"click":_vm.tapEvent}},[_vm._v("与小程序交互")])}
var staticRenderFns = []

export { render, staticRenderFns }